import { render, staticRenderFns } from "./PostingDetailEdit.vue?vue&type=template&id=1288c4b8&scoped=true&"
import script from "./PostingDetailEdit.vue?vue&type=script&lang=js&"
export * from "./PostingDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./PostingDetailEdit.vue?vue&type=style&index=0&id=1288c4b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288c4b8",
  null
  
)

export default component.exports